
<div class="dop-header">
    <div class="dop-subheading dop-majority">{{majoritySubheading}}</div>
</div>

<div [ngClass]="electionService.isMobile ? 'first-pref-table-phone' :'first-pref-table'">
        <table mat-table [dataSource]="dataSource" >
            <ng-container *ngFor="let col of columns; trackBy: trackByDistrictAndColumn; let i = index;" matColumnDef="{{col.column}}">
                <th mat-header-cell *matHeaderCellDef> 
                    <div *ngIf="col.isRightJustify===false">{{col.label}}</div>
                    <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.label}}</div>
                    <br/>
                    <div *ngIf="col.isRightJustify===false" style="margin-top: -7px;">
                        {{col.labelTwo}}
                    </div>
                    <div class="value-justify-right" style="margin-top: -7px;" *ngIf="col.isRightJustify===true">
                        {{col.labelTwo}}
                    </div>
                    <!-- <br/>
                    <div *ngIf="col.colourCode!==null" class="value-justify-right" style="margin-left: -7px;" >
                        <mat-icon class="party-colour2" [ngStyle]="{'color': col.colourCode}">
                            rectangle
                        </mat-icon>
                    </div> -->
                </th>
                <td mat-cell *matCellDef="let element" >
                    <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
                        <mat-icon class="party-colour" [ngStyle]="{'color': element.colourCode}">
                            rectangle
                        </mat-icon>
                    </div>
                    <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isRightJustify&&col.isPercent===false">
                        <div [ngClass]="isBold(element[0]) ? 'text-bold' : 'text-plain'">
                            {{
                              element[col.column] !== undefined && element[col.column] !== null && element[col.column] !== ''
                                ? element[col.column]
                                : (element[0] === 'Final %' || element[0] === 'Election Result' || element[col.column] === '' ? '' : '0')
                            }}
                        </div>
                    </div>
                    <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isPercent">
                        <div *ngIf="col.isColourBar">
        
                        </div>
                        <div [ngClass]="isBold(element[0]) ? 'text-bold' : 'text-plain'">
                            {{(element[col.column]===null?'n/a':element[col.column])/100|percent :'1.1-1'}}
                        </div>
                    </div>
                    <div [style.min-width.px]="col.minWidth" *ngIf="col.isRightJustify===false&&col.isColour===false">
                        <div [ngClass]="isBold(element[0]) ? 'text-bold' : 'text-plain'">
                            {{element[col.column]}}
                        </div>
                    </div>
                </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
        </table>
</div>
